import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEqual } from "lodash";
import PropTypes from "prop-types";
import { editProjectTemplateElement } from "~/store/actions/actions.projectTemplateElements";
import { getProjectTemplateElementById } from "~/store/selectors/selector.projectTemplateElements";
import { TemplateTaskPanel } from "./TemplateTaskPanel.jsx";

export const TemplateTaskPanelContainer = ({ taskId, templateId }) => {
  const dispatch = useDispatch();

  const task = useSelector((state) => getProjectTemplateElementById(state, taskId));

  const handleChange = (updates) => {
    const updatedTask = { ...task, ...updates };
    if (!isEqual(task, updatedTask)) {
      dispatch(editProjectTemplateElement(taskId, templateId, updatedTask));
    }
  };
  return (
    <TemplateTaskPanel
      task={task}
      onChange={handleChange}
    />
  );
};

TemplateTaskPanelContainer.propTypes = {
  taskId: PropTypes.number.isRequired,
  templateId: PropTypes.number.isRequired,
};
